export const auth = {
  startHeadline: "Your child's maths, week by week",
  startSub:
    'See their progress, read weekly reports and set the practice they need, all in one place.',
  getStarted: 'Get started',
  haveAccountCta: 'I already have an account',
  welcomeBack: 'Welcome back!',
  alreadyHadAccount: 'You already have an account — welcome back.',
  noAccount: "Don't have an account?",
  signUp: 'Sign up',

  signupTagline1: "Follow your child's",
  signupTagline2: 'math, week by week',
  haveAccount: 'Already have an account?',
  logIn: 'Log in',
  termsPrefix: 'By registering, you agree to the',
  termsOfService: 'Terms of Service',
  termsAnd: '&',
  privacyPolicy: 'Privacy Policy',

  phoneNumberLabel: 'PHONE NUMBER',
  phonePlaceholder: 'e.g. 123456789',
  countryCode: 'Country code',
  sendingOtp: 'Sending OTP...',
  createAccount: 'Create an account',
  logInCta: 'Log in',
  checkYourMessages: 'Check your messages',
  sentTo: 'Sent to',
  resendIn: 'Resend OTP in {seconds}s',
  resendOtp: 'Resend OTP',
  verifying: 'Verifying...',
  verifyOtp: 'Verify OTP',
  backToPhone: 'Back to phone number',
  errPhoneRequired: 'Phone number is required',
  errPhoneInvalid: 'Enter a valid phone number',
  errSendOtp: "Couldn't send the code. Please try again.",
  errResendOtp: "Couldn't resend the code. Please try again.",
  errInvalidOtp: 'That code is not right. Check it and try again.',
  errCodeExpired: 'That code has expired. Send a new code and try again.',
  errTooManyAttempts: 'Too many attempts. Please wait a minute and try again.',
  errQuotaExceeded: "We can't send codes right now. Please try again later.",
  errCaptcha: "We couldn't check that you're not a robot. Refresh the page and try again.",
  errNetwork: 'No connection. Check your internet and try again.',
  errUserDisabled: "This account can't be used right now. Please contact support.",

  signInWithEmail: 'Sign in with email',
  emailAddressLabel: 'EMAIL ADDRESS',
  emailPlaceholder: 'name@example.com',
  passwordLabel: 'PASSWORD',
  passwordSignupPlaceholder: 'Min. 8 characters',
  confirmPasswordLabel: 'CONFIRM PASSWORD',
  errPasswordMismatch: 'Passwords do not match.',
  verifyEmailTitle: 'Verify your email',
  verifyEmailBefore: "We've sent a verification link to",
  verifyEmailAfter:
    'Open it to finish creating your account. This page continues on its own once you have.',
  completingSignup: 'Completing sign up...',
  pleaseWait: 'Please wait...',
  forgotPassword: 'Forgot your password?',
  backToOptions: 'Back to options',
  resetPasswordTitle: 'Reset your password',
  resetLinkSentBefore: "We've sent a password reset link to",
  backToLogin: 'Back to login',
  sending: 'Sending...',
  sendResetLink: 'Send reset link',
  errEmailRequired: 'Email is required.',
  errEmailInvalid: 'Invalid email address.',
  errSendResetEmail: 'Failed to send reset email.',
  setNewPasswordTitle: 'Set new password',
  passwordResetSuccess:
    'Your password has been successfully reset. You can now log in with your new password.',
  resettingPasswordFor: 'Resetting password for',
  newPasswordLabel: 'New password',
  confirmNewPasswordLabel: 'Confirm new password',
  savePassword: 'Save password',
  errPasswordMin: 'Password must be at least 8 characters.',
  errResetLinkInvalid: 'The password reset link is invalid or has expired.',
  errResetPassword: 'Failed to reset password.',
  errInvalidEmailPass: 'Invalid email or password.',
  errEmailExists: 'An account already exists with this email address.',
  errEmailNotVerified: 'Verify your email first. Open the link we sent to your inbox.',
  resendVerification: 'Resend verification link',
  verificationResent: 'Link sent. Open it, then log in again.',
  errResendFailed: "Couldn't resend the link. Wait a minute and try again.",
  errAuthFailed: 'Authentication failed. Please try again.',
  errWeakPassword: 'Choose a stronger password of at least 8 characters.',

  logInWithPhone: 'Log in with Phone',
  logInWithEmail: 'Log in with Email',
  signUpWithPhone: 'Sign up with Phone',
  signUpWithEmail: 'Sign up with Email',

  aboutYou: 'A little about you',
  aboutYouSub: 'So reports and messages come addressed to you.',
  yourNameLabel: 'YOUR NAME',
  namePlaceholder: 'e.g. Aishah binti Rahman',
  appLanguageLabel: 'APP LANGUAGE',
  saving: 'Saving…',
  continueLabel: 'Continue',
  changeLaterNote: 'You can change these later in Profile.',
  changeNameLaterNote: 'You can change your name later in Profile.',
  errNameRequired: 'Name is required',
  errSaveDetails: 'Failed to save your details',

  close: 'Close',
  freeTrialHeading: 'Free Trial for {days} days',
  soloTrialPrefix: 'Family Solo starts with a',
  soloTrialDays: '{days}-day free trial',
  colFree: 'Free',
  colSolo: 'Solo',
  rowFollow: "Follow your child's activity",
  rowReports: 'Progress reports',
  rowAssign: 'Assign homework',
  rowPapers: 'Exam papers & worksheets',
  limited: 'Limited',
  included: 'Included',
  notIncluded: 'Not included',
  freeStaysFree:
    'Free stays free — you keep the dashboard, activity and news for as long as you like. IGCSE papers need the + IGCSE tier.',
  startFreeTrial: 'Start free trial',
  continueWithFree: 'Continue with Free',

  showPassword: 'Show password',
  hidePassword: 'Hide password',
  verifyEmailPage: {
    invalidLink: 'Invalid verification link.',
    expired: 'This verification link has expired.',
    used: 'This verification link is invalid or has already been used.',
    error: 'An error occurred during verification.',
    newSent: 'A new verification email has been sent.',
    sendFailed: 'Failed to send verification email.',
    checking: 'Verifying your email...',
    verified: 'Email Verified!',
    verifiedBody: 'Your email address has been successfully updated. You can now use it to log in.',
    continue: 'Continue',
    failed: 'Verification Failed',
    requestNewLink: 'Request a new link',
    backToProfile: 'Back to Profile',
    backToLogin: 'Back to Login',
  },
  errNoAccountForNumber:
    'No account uses this number. If you changed your number, log in with the new one. Otherwise, sign up.',
  errNoAccountForEmail:
    'No account uses this email. If you signed up with your phone number, log in with it, then add this email under Your details. Otherwise, sign up.',
  errNumberHasAccount: 'This number already has an account. Log in instead.',
} as const;
